<script setup lang="ts">
import { ref, onMounted } from 'vue'

const props = withDefaults(
  defineProps<{
    label: string
    defaultOpen?: boolean
    alwaysOpen?: boolean
  }>(),
  {
    defaultOpen: true,
    alwaysOpen: false,
  },
)

const storageKey = `subject-section-${props.label}`

const isOpen = ref(props.defaultOpen)

onMounted(() => {
  if (props.alwaysOpen) return
  const stored = localStorage.getItem(storageKey)
  if (stored !== null) {
    isOpen.value = stored === 'true'
  }
})

function toggle() {
  if (props.alwaysOpen) return
  isOpen.value = !isOpen.value
  localStorage.setItem(storageKey, String(isOpen.value))
}
</script>

<template>
  <div class="border border-border rounded bg-surface-container px-4 py-3">
    <button
      type="button"
      class="w-full flex items-center justify-between"
      :class="{ 'cursor-default': alwaysOpen }"
      @click="toggle"
    >
      <span class="text-[10px] uppercase tracking-widest">{{ label }}</span>
      <span
        v-if="!alwaysOpen"
        class="material-symbols-outlined text-[16px] text-outline transition-transform duration-200"
        :class="isOpen ? 'rotate-180' : ''"
      >expand_more</span>
    </button>
    <div v-if="isOpen || alwaysOpen" class="space-y-3 mt-3">
      <slot />
    </div>
  </div>
</template>
